import type { StickerIllustrationProps } from '../Sticker';

export const EggStickerIllustration = ({ size }: StickerIllustrationProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 90 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.4517 86.4893C23.8278 84.1785 16.952 78.7216 13.0444 70.9475C9.1465 63.1928 8.31024 53.3619 11.2743 42.4157C14.2268 31.5121 20.4637 21.2805 28.103 14.2755C35.6848 7.32334 45.1465 3.14636 54.3518 5.61291C63.5313 8.07262 69.819 16.4373 73.081 26.2818C76.3696 36.2064 76.8242 48.2444 73.8614 59.1859C70.8843 70.1801 64.9555 78.2063 57.4547 82.8907C49.9532 87.5754 41.0634 88.7968 32.4517 86.4893Z"
      fill="#F6DEE3"
      stroke="white"
      strokeWidth="5.625"
    />
    <mask id="mask0_9413_138" maskUnits="userSpaceOnUse" x="12" y="7" width="62" height="78">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.6164 8.32798C37.8445 4.10189 19.6291 22.3236 13.9914 43.1436C8.35357 63.9637 17.4146 79.5484 33.1866 83.7745C48.9586 88.0006 65.507 79.2779 71.1447 58.4579C76.7825 37.6378 69.3884 12.5541 53.6164 8.32798Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_9413_138)">
      <path
        d="M81.5307 50.676L65.635 59.8254L56.5098 43.9716L40.6141 53.121L31.4889 37.2673L15.5932 46.4167L6.46796 30.563"
        stroke="#E39EAC"
        strokeWidth="5.61363"
        strokeLinecap="round"
      />
      <path
        d="M77.9629 64.7883L62.0672 73.9377L52.9419 58.084L37.0462 67.2334L27.921 51.3797L12.0253 60.529L2.90009 44.6753"
        stroke="#E39EAC"
        strokeWidth="5.61363"
        strokeLinecap="round"
      />
      <path
        d="M85.0986 36.5636L69.2029 45.713L60.0777 29.8592L44.182 39.0086L35.0568 23.1549L19.1611 32.3043L10.0358 16.4506"
        stroke="#E39EAC"
        strokeWidth="5.61363"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
